import moment from "moment";
import { createDataPointProcessor } from "../utils/dataPointProcessor";
import { applyLineGraphState } from "../utils/lineGraphState";
import {
  initializeDictionaries,
  initializeEmotionDict,
  initializeActionDictionaries,
} from "../utils/dictionaries";
import { updateEmotions } from "./emotionHandler";
import {
  transform,
  transformActions,
  transformFilteredData,
  transformStudentSupportData,
  transformAllActions,
  computeParticipationPercentChange,
} from "../utils/transformers";
import {
  processAllDistricts,
  processAllSchoolsInDistrict,
  processSpecificSchool,
} from "../utils/processSchools";
import {
  processSpecificClass,
  processSpecificStudent,
} from "../utils/processClasses";

export function handlePercentage(state, percentage) {
  const { currentDict, compareDict } = initializeDictionaries();
  const { currentActionDict, compareActionDict } =
    initializeActionDictionaries();
  const currentParticipants = new Set();
  const compareParticipants = new Set();
  const emotionDict = initializeEmotionDict();
  let impactfulActions = { action: {}, emotion: {} };
  let updateState = {};
  let filterDataPoints = [];
  let studentEmotionData = {};
  let studentSupportData = {};
  const bigFiveFilteredData = [];
  const lineGraphSourceData = [];
  let tooltipCounts = initializeEmotionDict();

  const now = moment();
  const currentDate = moment().subtract(state.filterAmountCurrent);
  const compareDate = moment().subtract(
    state.filterAmountCurrent + state.filterAmountCompare
  );
  let allEmotions = state.multiEmotion.emotions;

  const processDataPoint = createDataPointProcessor(
    currentDate,
    compareDate,
    now,
    state.chosenEmotion,
    currentDict,
    compareDict,
    currentActionDict,
    compareActionDict,
    impactfulActions,
    filterDataPoints,
    studentEmotionData,
    studentSupportData,
    bigFiveFilteredData,
    state.selectedTimes,
    state.selectedSubOptions,
    state.helpfulFilter,
    tooltipCounts,
    currentParticipants,
    compareParticipants,
    allEmotions,
    lineGraphSourceData
  );

  if (state.chosenDistrict === "All Districts") {
    processAllDistricts(state, processDataPoint);
  } else if (state.chosenSchool === "All Schools") {
    processAllSchoolsInDistrict(state, processDataPoint);
  } else if (state.chosenClass === "All Classes") {
    processSpecificSchool(state, state.chosenSchool, processDataPoint);
  } else if (state.chosenStudent === "All Students") {
    processSpecificClass(state, state.chosenClass, processDataPoint);
  } else {
    processSpecificStudent(state, state.chosenStudent, processDataPoint);
  }

  updateState.filteredDataPoints = filterDataPoints;
  applyLineGraphState(updateState, lineGraphSourceData, state.chosenTime, now);
  //  these should not impact this data so dont change it
  // updateState.bigFiveFilteredData = bigFiveFilteredData;

  updateEmotions(
    state.feeling,
    state.filterAmountCurrent,
    state.chosenDistrict,
    state,
    emotionDict,
    updateState
  );

  transform(currentDict, compareDict, updateState);
  transformAllActions(currentActionDict, compareActionDict, updateState);
  transformActions(impactfulActions, updateState);
  transformFilteredData(studentEmotionData, percentage, updateState);
  transformStudentSupportData(studentSupportData, percentage, updateState);
  computeParticipationPercentChange(
    currentParticipants,
    compareParticipants,
    updateState
  );
  return updateState;
}
